import { IPurchaseStateWithCustomerRelationship } from "@smartrr/shared/entities/PurchaseState";
import { parseSubscriptionShippingErrorForMerchant } from "@smartrr/shared/utils/parseSubscriptionShippingError";
import { useCallback } from "react";

import { useToast } from "@vendor-app/app/_sharedComponents/Toast/ToastProvider";
import { bulkUpdateCustomerPurchaseStateLineItem } from "@vendor-app/app/_state/actionCreators/customerPurchaseState";
import { useSmartrrVendorDispatch } from "@vendor-app/app/_state/typedVendorReduxHooks";
import { ILineItemToUpdate } from "@vendor-app/app/AdminRoute/AdminSubscriptionDetailsRoute/libs";

export const useUpdateItemsInBulk = (
  customerPurchaseState: IPurchaseStateWithCustomerRelationship,
  onError?: () => void,
  onCommitStart?: () => void,
  onCommitEnd?: () => void
) => {
  const dispatch = useSmartrrVendorDispatch();
  const { addToast } = useToast();

  return useCallback(
    async (lineItems: ILineItemToUpdate[]) => {
      if (!(customerPurchaseState && customerPurchaseState.custRel)) {
        return;
      }

      onCommitStart && onCommitStart();
      await dispatch(
        bulkUpdateCustomerPurchaseStateLineItem({
          custRelId: customerPurchaseState.custRel.id,
          cpsId: customerPurchaseState.id,
          lineItems,
        })
      )
        .then(res => {
          if (res.type === "BULK_UPDATED_CPS_LINE_ITEM") {
            addToast("Subscription updated");
          }
          if (res.type === "ERROR_BULK_UPDATING_CPS_LINE_ITEM") {
            addToast(
              parseSubscriptionShippingErrorForMerchant(res.payload.errorMessage, "Error updating subscription"),
              true
            );
            onError && onError();
          }
        })
        .catch(error => {
          addToast(parseSubscriptionShippingErrorForMerchant(error, "Error updating subscription"), true);
          onError && onError();
        });
      onCommitEnd && onCommitEnd();
    },
    [customerPurchaseState]
  );
};
